<template>
  <div class="row">
    <div class="col-2"></div>
    <div class="col-8">
      <div class="d-flex justify-content-start">
        <div>
          <font-awesome-icon :icon="['fas', 'circle']" />
        </div>
        <div>線上客服</div>
      </div>
      <hr />
      <div
        class="text-left"
      >若您在進行購買時，遇到 網頁無法顯示 / 無法進行下一步結帳 / 信箱沒收到訂購通知信時，請利用本系統詳細填寫資料並送出，以利我們幫您解決問題，謝謝您：</div>
      <hr />
      <div class="form-group row">
        <label for="inputName" class="col-2 text-right col-form-label">您的姓名</label>
        <div class="col-10 text-left">
          <input type="text" class="form-control" id="inputName" />
        </div>
      </div>
      <div class="form-group row">
        <label for="inputEmail" class="col-2 text-right col-form-label">Email</label>
        <div class="col-10 text-left">
          <input type="email" class="form-control" id="inputEmail" />
        </div>
      </div>
      <div class="form-group row">
        <label for="inputPhone" class="col-2 text-right col-form-label">聯絡電話</label>
        <div class="col-10 text-left">
          <input type="tel" class="form-control" id="inputPhone" />
        </div>
      </div>
      <div class="form-group row">
        <label for="inputPhone" class="col-2 text-right col-form-label">回報類型</label>
        <div class="col-10 text-left">
          <b-form-radio-group
            id="radio-group"
            name="radio-sub-component"
            v-model="selected"
            :options="options"
          ></b-form-radio-group>
          <small>選擇您要回報購物問題/建議回饋</small>
        </div>
      </div>
      <div v-if="selected">
        <div class="form-group row">
          <label for="quesDate" class="col-2 text-right col-form-label">發生問題日期</label>
          <div class="col-4 text-left">
            <div id="quesDate" class="d-flex align-items-center">
              <input type="text" class="form-control text-right" placeholder="月" />
              <div>月</div>
              <input type="text" class="form-control text-right" placeholder="日" />
              <div>日</div>
              <input type="text" class="form-control text-right" placeholder="0-23" />
              <div>時</div>
              <input type="text" class="form-control text-right" placeholder="0-59" />
              <div>分</div>
            </div>
            <small>ex:2019 12 18 18點40分</small>
          </div>
        </div>
        <div class="form-group row">
          <label for="leaveMsg" class="col-2 text-right col-form-label">請假事由</label>
          <div class="col-10">
            <b-form-textarea id="leaveMsg" placeholder="請詳細描述您遇到的問題過程。" rows="4"></b-form-textarea>
            <small>(※若您輸入資料與訂單不符則無法請假成功，請送出資料前再三確認！)</small>
          </div>
        </div>
      </div>
      <div v-if="!selected">
        <div class="form-group row">
          <label for="suggestMsg" class="col-2 text-right col-form-label">建議事項</label>
          <div class="col-10">
            <b-form-textarea id="suggestMsg" placeholder="請填寫您的想法、建議描述。" rows="4"></b-form-textarea>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <button type="button" class="btn btn-primary">送出</button>
        <button type="button" class="btn btn-primary">清除</button>
      </div>
    </div>
    <div class="col-2"></div>
  </div>
</template>

<script>
import onlineService from '@/js/onlineService';

export default onlineService;
</script>

<style>
</style>
